var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.947 5.766H8.89V3.43A3.434 3.434 0 005.461 0a3.434 3.434 0 00-3.43 3.43v2.336h-.056C.886 5.766 0 6.652 0 7.742v4.72c0 2.03 1.65 3.68 3.679 3.68h3.564a3.683 3.683 0 003.68-3.68v-4.72c0-1.09-.887-1.976-1.976-1.976zM3.672 3.43c0-.987.803-1.79 1.79-1.79.986 0 1.788.803 1.788 1.79v2.336H3.672V3.43zm5.61 9.033A2.04 2.04 0 017.242 14.5H3.68a2.04 2.04 0 01-2.038-2.038V7.742c0-.185.15-.335.334-.335h6.972c.184 0 .334.15.334.335v4.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.461 9.359a.82.82 0 00-.82.82v1.55a.82.82 0 101.64 0v-1.55a.82.82 0 00-.82-.82z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.42d5c1c4.svg";
export { ForwardRef as ReactComponent };